module.exports = __webpack_public_path__ + "img/PL09244.f2eb8458.png";